module.exports = __webpack_public_path__ + "static/media/page404.84b1ce86.svg";